/**
 * Generic hook for admin list endpoints (tracking API).
 * Returns { data, isLoading, error, refetch } for use with TrackingApiListPage.
 */
import useSWR from "swr";
import { useAuthentication } from "./useAuthentication";

export function useTrackingAdminList<T>(
  key: string,
  fetcher: (accessToken: string | undefined) => Promise<T[]>
) {
  const { user } = useAuthentication();
  const token = user?.auth?.access_token;

  const { data, error, isLoading, mutate } = useSWR<T[]>(
    token ? [key, token] : null,
    () => fetcher(token),
    { revalidateOnFocus: false }
  );

  return {
    data: Array.isArray(data) ? data : [],
    isLoading,
    error,
    refetch: mutate,
  };
}
